import React, { FC } from 'react';
import { Typography } from '../../../../shared/typography';
import Styled from './styles';

interface IInputProps {
	title: string;
	value?: any;
	fields?: any;
	callback(props: any): void;
}

const Description: FC<IInputProps> = ({ title, value, fields, callback }) => {
	return (
		<div style={{ width: '100%' }}>
			<div>
				<Typography type="bold" size="medium" text={title} />
			</div>
			<Styled.StyledInput
				value={value}
				onChange={event => callback(event.target.value)}
				placeholder="Add description"
			/>
		</div>
	);
};

export default Description;
